/**
 * Generates a unique invitation code for teams
 * Format: 6 characters, alphanumeric, uppercase
 */
export const generateInvitationCode = (): string => {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  let result = '';
  for (let i = 0; i < 6; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
};

/**
 * Validates invitation code format
 */
export const isValidInvitationCode = (code: string): boolean => {
  return /^[A-Z0-9]{6}$/.test(code);
};

/**
 * Formats invitation code for display (adds hyphens for readability)
 */
export const formatInvitationCode = (code: string | undefined): string => {
  if (!code) return 'N/A';
  return code.replace(/(.{3})(.{3})/, '$1-$2');
};
